import * as React from 'react';
import classNames from 'classnames';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import Tooltip from '../../../components/Tooltip';
import { __, setTableParams } from '../../../core/utils';
import {
  removeTaskFromGroup,
  removeTaskFromSubstage,
} from '../../../redux/actions/table/all_tasks';
import ArrowDoubleRightSmallIcon from '../../../assets/images/arrow-double-right-small-15x15.svg';
import CloseMiddleIcon from '../../../assets/images/close-middle-15x15.svg';
import styles from '../../../styles/flyouts/tasks/Relations.scss';
import { TaskTypeIcon } from './TaskRelationVisuals';
import { confirmRelationRemoval, openRelationTask } from './relationHelpers';

const TaskPath = ({ data, match }) => {
  const pathItems = data.path || [];

  const pathTaskLabel = (item) => (
    <span>
      {item.identifier && <>T-{item.identifier} &middot; </>}
      {item.label}
    </span>
  );

  const removePath = (event) => {
    event.stopPropagation();

    const pathType = _.get(_.last(pathItems), 'type');

    confirmRelationRemoval({
      description: __(
        'tasks.all-tasks.flyout.relations.are-you-sure-remove-path',
      ),
      notification: __('tasks.all-tasks.flyout.relations.path-removed'),
      remove: () =>
        pathType === 'group'
          ? removeTaskFromGroup(data.id)
          : removeTaskFromSubstage(data.id),
      taskId: data.id,
      match,
    });
  };

  return (
    <>
      <div className={classNames(styles.flex, styles.sectionHeader)}>
        <div className={styles.f1}>
          <label className={styles.label}>
            {__('tasks.all-tasks.flyout.relations.path')}
          </label>
          <div className={styles.pathDescription}>
            {__('tasks.all-tasks.flyout.relations.path-description')}
          </div>
        </div>
        <div className={styles.headerActions}>
          <button
            onClick={() =>
              setTableParams('all_tasks', {
                add_parent_task_wizard: data.id,
              })
            }
          >
            {__('button.change-path')}
          </button>
        </div>
      </div>

      {!_.isEmpty(pathItems) && (
        <div className={styles.pathRow}>
          <div className={styles.pathItems}>
            {_.map(pathItems, (item, index) => (
              <React.Fragment key={`${item.type}-${item.id}-${index}`}>
                {item.type === 'substage' ? (
                  <div className={styles.pathItem}>
                    <span className={styles.pathType}>
                      {__('tasks.all-tasks.flyout.relations.substage')}
                    </span>
                    <span className={styles.pathName}>{item.label}</span>
                  </div>
                ) : (
                  <div className={styles.pathTaskWrapper}>
                    <span className={styles.pathType}>
                      {__('tasks.all-tasks.flyout.relations.group-task')}
                    </span>
                    <div className={styles.pathTask}>
                      <TaskTypeIcon type={item.type} />
                      <div
                        onClick={() => openRelationTask(item, match)}
                        className={classNames(
                          styles.pathTaskLink,
                          item.can_view && item.id
                            ? styles.clickable
                            : styles.disabled,
                        )}
                      >
                        {item.can_view ? (
                          pathTaskLabel(item)
                        ) : (
                          <Tooltip
                            text={__(
                              'tasks.all-tasks.flyout.parent-tasks.tooltip.private-parent-task.no-access',
                            )}
                          >
                            {pathTaskLabel(item)}
                          </Tooltip>
                        )}
                        {item.can_view && item.id && (
                          <ArrowDoubleRightSmallIcon />
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {index < pathItems.length - 1 && (
                  <span className={styles.pathSeparator}>›</span>
                )}
              </React.Fragment>
            ))}
          </div>
          <div className={styles.pathActions}>
            <Tooltip text={__('tasks.all-tasks.flyout.relations.remove-path')}>
              <CloseMiddleIcon onClick={removePath} />
            </Tooltip>
          </div>
        </div>
      )}
    </>
  );
};

export default withRouter(TaskPath);
